import { publishChannel, subscribeChannel } from './channelUtils';

export function sendInitialDataStart() {

    publishChannel('initial-data-start');

}

export function sendInitialDataDone() {

    publishChannel('initial-data-done');

}

export function requestInitialData() {
    
    publishChannel('request-initial-data');

}

export function notifyFiltersClosed() {

    publishChannel('filters-closed');

}

export function notifyTripsInitialized() {
    publishChannel('trips-initialized');
}

export function requestHourRange() {
    publishChannel('request-hour-range');
}

export function listenMonitor(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'request-initial-data' &&
            tipo !== 'filters-closed' &&
            tipo !== 'trips-initialized' &&
            tipo !== 'request-hour-range' &&
            tipo !== 'initial-data-start' &&
            tipo !== 'initial-data-done'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}